<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles.js'
	import { get_block_content, get_finished_content, delete_content } from '../library/scripts/utils.js'
	import {
		storeUploader,
		storeActiveBlock,
		storeUpdate,
		storeUpdateSingle,
		storeFinishedContent,
		storeShowFinishedBlocks,
		storeShowSliderButton,
		storeShowGalleryButton,
		storeLogo,
		storeData,
		storeShowCreateButtons,
		storeSingleImageBlock,
		storeIsLinked,
		storeLinked,
		storeRedirect1,
		storeRedirect2,
		storeRedirect3,
		storeRedirect4,
	} from '../library/scripts/Store.svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import FileUploader from '../library/FileUploader.svelte'
	import DropFiles from '../library/LayoutStuff/DropFiles.svelte'
	import TwoCols from '../library/columLayouts/TwoCols.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'
	import Select from '../library/selectors/SimpleSelect.svelte'

	export let blockName = null
	export let maxContent = 4

	let linkedPages = []
	let columnLinks = []

	// for links
	let setLink1 = false
	let setLink2 = false
	let setLink3 = false
	let setLink4 = false

	//the configFile
	let configFile

	const stoData = storeData.subscribe((value) => {
		configFile = value
		// reset columnLinks to prevent double entries
		columnLinks = []
		if (value) {
			value.blocks.forEach((block) => {
				if (block.isLinked && !linkedPages.includes(block.blockName)) {
					linkedPages.push(block.blockName)
				}

				if (block.blockName.indexOf('Block') > -1 && !block.isLinked) {
					// get links of each column
					block.content.forEach((content) => {
						if (content.link) {
							columnLinks.push({
								block: block.blockName,
								id: content.id,
								link: content.link,
								imgDescription: content.imgDesc,
							})
						}
					})
				}

				storeLinked.set(linkedPages)
			})
		}
	})

	//if the logo is not uploaded "storeLogo" in Store is set to true
	//(must show logo button in "CreateBlockButtons")
	//must not show add logo
	let showLogoCheckbox
	const stoHasLogo = storeLogo.subscribe((value) => {
		value = value === true ? false : true
		showLogoCheckbox = value
	})

	//active block
	const stoActiveBl = storeActiveBlock.subscribe((value) => {
		blockName = value
	})

	let blockTitle = null
	let blockIntro = 'GALLERY'
	let showTitle = false
	let showIntro = false
	let stBtnText = 'create title'
	let stBtnIntro = 'create intro'

	//is this an update
	let isUpdate = false
	let closeUpdate = false
	let uploadCmd = 'upload'
	const stoUpdt = storeUpdate.subscribe((value) => {
		isUpdate = value
	})

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const inputBg = globals.adminInputBg
	const inputBgFocus = globals.adminInputBgFocus
	const buttonBgHover = globals.adminButtonBgHover
	const linkHover = globals.linkHover

	let showCreateContent = false
	let dropFiles = false

	let selectedID = null
	let idCounter = 1
	let deleteBlock = false
	let showSave = false

	//bindings
	let columnTitle = ''
	let columnText = ''
	let hasLogo = false

	//the accepted files
	const acceptedFiles = ['image/jpg', 'image/jpeg', 'image/png']

	//only one image per slide
	let showError = false

	//error message
	let message = ''
	let showOkButton = false

	let uploadFiles
	const stoUp = storeUploader.subscribe((value) => {
		uploadFiles = value
	})

	//columns
	let columnArray = []

	//preview images
	let PREVHEIGHT = 80
	let PREVWIDTH = 60
	let PREVLANDSCAPE = 120

	// links
	let link1 = false
	let link2 = false
	let link3 = false
	let link4 = false

	// values for links
	let link1Value = false
	let link2Value = false
	let link3Value = 'select page'
	let link4Value = false

	// image description if its a linked column
	let imgDesc1 = null
	let imgDesc2 = null
	let imgDesc3 = null
	let imgDesc4 = null

	let blocks = get_finished_content()

	blocks.then((value) => {
		storeFinishedContent.set({ finishedBlocks: value.finishedBlocks.sort(), linkedSites: value.linkedSites })
		if (updateSingle) storeFinishedContent.set({ finishedBlocks: [updateSingle], linkedSites: value.linkedSites })
	})

	// set column links for active block
	const set_links = () => {
		if ($storeActiveBlock.indexOf('Block') > -1) {
			columnLinks.forEach((links) => {
				if (links.block === $storeActiveBlock) {
					switch (links.id) {
						case 1:
							setLink1 = true
							link1Value = links.link
							storeRedirect1.set(link1Value)
							imgDesc1 = links.imgDesc
							if (link1Value.indexOf('http') > -1) link1 = 'linkUrl'
							if (link1Value.indexOf('Block') > -1) link1 = 'linkPage'
							if (link1Value.indexOf('#/') > -1) link1 = 'linkPage'
							break

						case 2:
							setLink2 = true
							link2Value = links.link
							storeRedirect2.set(link2Value)
							imgDesc2 = links.imgDesc
							if (link2Value.indexOf('http') > -1) link2 = 'linkUrl'
							if (link2Value.indexOf('Block') > -1) link2 = 'linkPage'
							if (link2Value.indexOf('#/') > -1) link2 = 'linkPage'
							break

						case 3:
							setLink3 = true
							link3Value = links.link
							storeRedirect3.set(link3Value)
							imgDesc3 = links.imgDesc
							if (link3Value.indexOf('http') > -1) link3 = 'linkUrl'
							if (link3Value.indexOf('Block') > -1) link3 = 'linkPage'
							if (link3Value.indexOf('#/') > -1) link3 = 'linkPage'
							break

						case 4:
							setLink4 = true
							link4Value = links.link
							storeRedirect4.set(link4Value)
							imgDesc4 = links.imgDesc
							if (link4Value.indexOf('http') > -1) link4 = 'linkUrl'
							if (link4Value.indexOf('Block') > -1) link4 = 'linkPage'
							if (link4Value.indexOf('#/') > -1) link4 = 'linkPage'
							break
					}
				}
			})
		}
	}

	//update
	$: if (isUpdate) {
		set_links()

		// for some reasons radio buttons selection only works if this is set!!
		console.log(link1, link2, link3, link4)
		console.clear()

		closeUpdate = true
		storeActiveBlock.set(blockName)
		storeShowCreateButtons.set(false)
		uploadCmd = 'update'
		deleteBlock = true
		columnArray = []
		const blocks = get_block_content(blockName)
		blocks.then(function (value) {
			storeSingleImageBlock.set(value[1].singleImageBlock)
			storeIsLinked.set(value[1].isLinked)
			hasLogo = value[1].hasLogo
			if (value[1].blockTitle) {
				showTitle = true
				blockTitle = value[1].blockTitle
				stBtnText = 'delete title'
			}

			if (value[1].intro) {
				showIntro = true
				blockIntro = value[1].intro
				stBtnIntro = 'delete intro'
			}

			showCreateContent = true

			for (let key in value[1].content) {
				//reset the background image
				if (value[1].content[key].backgroundImage) value[1].content[key].backgroundImage = null
				columnArray.push(value[1].content[key])
			}

			columnArray.forEach((item) => {
				let col = document.createElement('div')
				col.setAttribute('id', 'col_' + item.id)
				col.style.cursor = 'pointer'
				col.style.display = 'flex'
				col.style.flexDirection = 'column'
				col.style.alignItems = 'center'
				col.style.justifyContent = 'center'
				col.style.width = '100%'
				col.style.height = 'max(150px,min(15vmax, 230px)'
				col.style.height = 'clamp(150px,15vw, 230px)'
				col.style.background = inputBg
				col.style.marginRight = '5px'
				col.addEventListener('click', update_content)

				let colTitle = document.createElement('div')
				colTitle.setAttribute('id', 'title_' + item.id)
				colTitle.style.display = 'flex'
				colTitle.style.justifyContent = 'center'
				colTitle.style.width = '100%'
				colTitle.style.fontStyle = 'italic'
				colTitle.style.marginTop = '5px'
				colTitle.style.fontSize = fsS
				if (item.title) colTitle.innerText = item.title.slice(0, 15) + '...'

				let colText = document.createElement('div')
				colText.setAttribute('id', 'text_' + item.id)
				colText.style.display = 'flex'
				colText.style.justifyContent = 'center'
				colText.style.width = '100%'
				colText.style.marginTop = '10px'
				colText.style.fontSize = fsXS
				if (item.text) colText.innerText = item.text.slice(0, 15) + '...'

				let colImage = document.createElement('div')
				colImage.setAttribute('id', 'image_' + item.id)
				colImage.style.marginTop = '5px'

				col.append(colTitle)
				col.append(colText)

				//add the image
				if (item.image) {
					const imageFile = url + '/' + blockName + '/thumbnail/' + item.image

					let image = new Image()
					image.src = imageFile
					image.onload = () => {
						let canvas = document.createElement('canvas')
						canvas.setAttribute('id', 'canv_' + item.id)
						let ctx = canvas.getContext('2d')

						if (image.width > image.height) {
							canvas.height = PREVHEIGHT
							canvas.width = PREVLANDSCAPE
						}

						if (image.width < image.height) {
							canvas.height = PREVHEIGHT
							canvas.width = PREVWIDTH
						}

						if (image.width === image.height) {
							canvas.height = PREVHEIGHT
							canvas.width = PREVHEIGHT
						}
						ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
						colImage.append(canvas)
						col.append(colImage)
					}
				}

				const toWait = setTimeout(() => {
					const preview = document.querySelector('#createContent')
					preview.append(col)
					storeUpdate.set(false)
					storeShowFinishedBlocks.set(false)
					showSave = true
					clearTimeout(toWait)
				}, 1)
			})
		})
	}

	//responsive
	$: if (window.innerWidth < 569) {
		PREVHEIGHT = 40
		PREVWIDTH = 13.5
		PREVLANDSCAPE = 60
	}

	$: if (window.innerWidth > 569) {
		PREVHEIGHT = 80
		PREVWIDTH = 60
		PREVLANDSCAPE = 120
	}

	//promisses
	let uploader = upload_block()

	// rest the links if create link is deselected
	$: if (!setLink1) {
		link1 = false
		link1Value = null
		imgDesc1 = null
		storeRedirect1.set(null)
	}
	$: if (!setLink2) {
		link2 = false
		link2Value = null
		imgDesc2 = null
		storeRedirect2.set(null)
	}
	$: if (!setLink3) {
		link3 = false
		link3Value = null
		imgDesc3 = null
		storeRedirect3.set(null)
	}
	$: if (!setLink4) {
		link4 = false
		link4Value = null
		imgDesc4 = null
		storeRedirect4.set(null)
	}

	// delete link if user switches the radio button from page to url and vice versa

	$: if ($storeRedirect1) {
		if ($storeRedirect1.indexOf('http') > -1 && link1 !== 'linkUrl') {
			link1 = 'linkPage'
			link1Value = null
			storeRedirect1.set(null)
		} else if ($storeRedirect1.indexOf('Block') > -1 || ($storeRedirect1.indexOf('#/') > -1 && link1 !== 'linkPage')) {
			link1 = 'linkUrl'
			link1Value = null
			storeRedirect1.set(null)
			imgDesc1 = null
		}
	}

	$: if ($storeRedirect2) {
		if ($storeRedirect2.indexOf('http') > -1 && link2 !== 'linkUrl') {
			link2 = 'linkPage'
			link2Value = null
			storeRedirect2.set(null)
		} else if ($storeRedirect2.indexOf('Block') > -1 || ($storeRedirect2.indexOf('#/') > -1 && link2 !== 'linkPage')) {
			link2 = 'linkUrl'
			link2Value = null
			storeRedirect2.set(null)
			imgDesc2 = null
		}
	}

	$: if ($storeRedirect3) {
		if ($storeRedirect3.indexOf('http') > -1 && link3 !== 'linkUrl') {
			link3 = 'linkPage'
			link3Value = null
			storeRedirect3.set(null)
		} else if ($storeRedirect3.indexOf('Block') > -1 || ($storeRedirect3.indexOf('#/') > -1 && link3 !== 'linkPage')) {
			link3 = 'linkUrl'
			link3Value = null
			storeRedirect3.set(null)
			imgDesc3 = null
		}
	}

	$: if ($storeRedirect4) {
		if ($storeRedirect4.indexOf('http') > -1 && link4 !== 'linkUrl') {
			link4 = 'linkPage'
			link4Value = null
			storeRedirect4.set(null)
		} else if ($storeRedirect4.indexOf('Block') > -1 || ($storeRedirect4.indexOf('#/') > -1 && link4 !== 'linkPage')) {
			link4 = 'linkUrl'
			link4Value = null
			storeRedirect4.set(null)
			imgDesc4 = null
		}
	}

	//functions
	const link_block = (e) => {
		columnArray.forEach((item) => {
			if (item.id === selectedID) {
				switch (selectedID) {
					case 1:
						link1Value = e.detail.name
						break

					case 2:
						link2Value = e.detail.name
						break

					case 3:
						link3Value = e.detail.name
						break

					case 4:
						link4Value = e.detail.name
						break
				}
			}
		})
	}
	const show_title = () => {
		showTitle = showTitle === false ? true : false
		blockTitle = null
		if (!showTitle) stBtnText = 'create title'
	}

	const show_intro = () => {
		showIntro = showIntro === false ? true : false
		blockIntro = null
		if (!showIntro) stBtnIntro = 'create intro'
	}

	const create_column_id = () => {
		if (columnArray.length + 1 > maxContent) {
			showError = true
			message = `maximal ${maxContent} columns per block`
			return
		}
		showCreateContent = true
		selectedID = null

		//wait for preview to be loaded
		const toWait = setTimeout(() => {
			storeShowFinishedBlocks.set(false)
			idCounter = columnArray.length + 1
			create_column(idCounter)
			clearTimeout(toWait)
		}, 1)
	}

	const create_column = (id) => {
		//add link if columnArray is empty
		columnArray.forEach((item) => {
			if (id !== item.id && !item.image && !item.title && !item.text && !document.querySelector('#link_' + item.id)) {
				const col = document.querySelector('#col_' + item.id)
				let colLink = document.createElement('div')
				colLink.setAttribute('id', 'link_' + item.id)
				colLink.style.display = 'flex'
				colLink.style.width = '100%'
				colLink.style.height = '100%'
				colLink.style.justifyContent = 'center'
				colLink.style.alignItems = 'center'
				colLink.innerText = 'click to create content'
				colLink.style.fontSize = fsS
				col.prepend(colLink)
			}
		})
		let col = document.createElement('div')
		col.setAttribute('id', 'col_' + id)
		col.style.cursor = 'pointer'
		col.style.display = 'flex'
		col.style.flexDirection = 'column'
		col.style.alignItems = 'center'
		col.style.justifyContent = 'center'
		col.style.width = '100%'
		col.style.height = '100%'
		col.style.background = inputBg
		col.style.marginRight = '5px'

		//the create text link
		let colLink = document.createElement('div')
		colLink.setAttribute('id', 'link_' + id)
		colLink.style.display = 'flex'
		colLink.style.width = '100%'
		colLink.style.height = '100%'
		colLink.style.justifyContent = 'center'
		colLink.style.alignItems = 'center'
		colLink.innerText = 'click to create content'
		colLink.style.fontSize = fsS

		let colTitle = document.createElement('div')
		colTitle.setAttribute('id', 'title_' + id)
		colTitle.style.width = '100%'
		colTitle.style.display = 'flex'
		colTitle.style.justifyContent = 'center'
		colTitle.style.fontSize = fsS
		colTitle.style.fontStyle = 'italic'
		colTitle.style.marginTop = '5px'

		let colText = document.createElement('div')
		colText.setAttribute('id', 'text_' + id)
		colText.style.width = '100%'
		colText.style.display = 'flex'
		colText.style.justifyContent = 'center'
		colText.style.width = '100%'
		colText.style.marginTop = '10px'
		colText.style.fontSize = fsS

		let colImage = document.createElement('div')
		colImage.setAttribute('id', 'image_' + id)
		colImage.style.marginTop = '5px'

		col.addEventListener('click', add_content)
		col.append(colLink)
		col.append(colTitle)
		col.append(colText)
		col.append(colImage)
		let createContent = document.querySelector('#createContent')
		createContent.append(col)
		columnArray.push({
			id: id,
			// css
			//image *** IMPORTANT*** !!!!!image MUST be on top of list!!!!!!
			image: null,
			imageWidth: 47,
			objectFit: 'cover',
			boxShadowX: 3,
			boxShadowY: 3,
			boxShadowBlur: 9,
			boxShadowColor: 'hsla(0,0%,0%,1)',
			imageBorderTopRadius: 0,
			imageBorderBottomRadius: 0,
			imageBorderLeftWidth: 1,
			imageBorderLeftStyle: 'solid',
			imageBorderLeftColor: 'hsla(0,0%,0%,1)',
			imageBorderTopWidth: 1,
			imageBorderTopStyle: 'solid',
			imageBorderTopColor: 'hsla(0,0%,0%,1)',
			imageBorderRightWidth: 1,
			imageBorderRightStyle: 'solid',
			imageBorderRightColor: 'hsla(0,0%,0%,1)',
			imageBorderBottomWidth: 1,
			imageBorderBottomStyle: 'solid',
			imageBorderBottomColor: 'hsla(0,0%,0%,1)',
			imageMarginTop: 10,
			imageMarginBottom: 0,
			imagePadding: 0,
			padding: 0,
			marginTop: 2,
			marginBottom: 2,
			backgroundColor: 'hsla(0,0%,100%,0)',
			borderTopRadius: 0,
			borderBottomRadius: 0,
			borderBackgroundImage: null,
			borderTopWidth: 0,
			borderTopStyle: 'solid',
			borderTopColor: 'hsla(0,0%,0%,1)',
			borderBottomWidth: 0,
			borderBottomStyle: 'solid',
			borderBottomColor: 'hsla(0,0%,0%,1)',
			borderLeftWidth: 0,
			borderLeftStyle: 'solid',
			borderLeftColor: 'hsla(0,0%,0%,1)',
			borderRightWidth: 0,
			borderRightStyle: 'solid',
			borderRightColor: 'hsla(0,0%,0%,1)',
			backgroundImage: null,
			columnBoxShadowX: 0,
			columnBoxShadowY: 0,
			columnBoxShadowBlur: 0,
			columnBoxShadowColor: 'hsla(0,0%,0%,1)',

			//title
			title: null,
			titleWidth: 100,
			titleHeight: 0,
			titlePosTop: 0,
			titlePosLeft: 0,
			titleAlignHorizontal: 'center',
			titleAlignVertical: 'center',
			titleFontFamily: 'Lucida Sans',
			titleFontSize: fsL,
			titleFontColor: 'hsla(0,0%,0%,1)',
			titleFontWeight: 'bold',
			titleFontStyle: 'italic',
			titleFontDeco: 'none',
			titleBackgroundColor: 'hsla(0,0%,100%,0)',
			titleMarginTop: 0,
			titleMarginBottom: 0,
			titlePadding: 0,
			titleColumnShadowColor: 'hsla(0,0%,0%,1)',
			titleColumnShadowOffsetX: 0,
			titleColumnShadowOffsetY: 0,
			titleColumnShadowBlur: 0,
			titleColumnBorderRadius: 0,

			//text
			text: null,
			textPosTop: 100,
			textPosLeft: 0,
			textWidth: 100,
			textHeight: 0,
			textAlign: 'center',
			textAlignHorizontal: 'center',
			textAlignVertical: 'center',
			textFontFamily: 'Lucida Sans',
			textFontSize: fsN,
			textFontColor: 'hsla(0,0%,0%,1)',
			textFontWeight: 'normal',
			textFontStyle: 'normal',
			textFontDeco: 'none',
			textBackgroundColor: 'hsla(0,0%,100%,0)',
			textMarginTop: 1,
			textMarginBottom: 0,
			textPadding: 0,
			link: false,
			linkHover: 'hsla(235,88%,50%,1)',
			imgDesc: null,
		})
	}

	const delete_column = () => {
		let col = document.querySelector('#col_' + selectedID)
		if (columnArray.length < 2) {
			showError = true
			message = 'single column can not be deleted'
			return
		}

		//remove the column from array
		columnArray.splice(selectedID - 1, 1)

		//remove the column from DOM
		if (col) {
			col.remove()
			selectedID = null
		}

		//reorder ids
		const preview = document.querySelector('#createContent')
		preview.childNodes.forEach((child, index) => {
			if (child.id.indexOf('col_') > -1) {
				child.id = 'col_' + (index + 1)
				if (child.lastChild.childNodes.length > 0) child.lastChild.childNodes[0].id = 'canv_' + (index + 1)
			}
			child.childNodes.forEach((subChild) => {
				if (subChild.id.indexOf('link_') > -1) subChild.id = 'link_' + (index + 1)
				if (subChild.id.indexOf('title_') > -1) subChild.id = 'title_' + (index + 1)
				if (subChild.id.indexOf('text_') > -1) subChild.id = 'text_' + (index + 1)
				if (subChild.id.indexOf('image_') > -1) subChild.id = 'image_' + (index + 1)
				columnArray[index].id = index + 1
			})
		})
	}

	const update_content = (e) => {
		// set the storeIsLinked to true if the block name exists in linkedPages
		if (linkedPages.includes(blockName)) storeIsLinked.set(true)

		//reset title and text
		columnTitle = ''
		columnText = ''
		selectedID = parseInt(e.target.id.split('_')[1])

		const link = document.querySelector('#link_' + selectedID)
		if (link) link.remove()

		//add link if columnArray is empty
		columnArray.forEach((item) => {
			if (
				selectedID !== item.id &&
				!item.image &&
				!item.title &&
				!item.text &&
				!document.querySelector('#link_' + item.id)
			) {
				const col = document.querySelector('#col_' + item.id)
				let colLink = document.createElement('div')
				colLink.setAttribute('id', 'link_' + item.id)
				colLink.style.display = 'flex'
				colLink.style.width = '100%'
				colLink.style.height = '100%'
				colLink.style.justifyContent = 'center'
				colLink.style.alignItems = 'center'
				colLink.innerText = 'click to create content'
				colLink.style.fontSize = fsS
				col.prepend(colLink)
			}
		})

		//check if has image
		const image = document.querySelector('#image_' + selectedID)
		if (image) {
			if (image.childNodes.length < 1) dropFiles = true
			else {
				dropFiles = false
			}
		} else {
			dropFiles = true
		}

		//if column is set already we use saved values
		if (columnArray[selectedID - 1]) {
			if (columnArray[selectedID - 1].title) columnTitle = columnArray[selectedID - 1].title
			if (columnArray[selectedID - 1].text) columnText = columnArray[selectedID - 1].text
			return
		}
	}

	const add_content = (element) => {
		let colID = null
		let id = null
		colID = element.target.parentElement.id
		id = parseInt(colID.split('_')[1])

		//remove the click info
		document.querySelector('#link_' + id).remove()

		showSave = true

		//add link if columnArray is empty
		columnArray.forEach((item) => {
			if (id !== item.id && !item.image && !item.title && !item.text && !document.querySelector('#link_' + item.id)) {
				const col = document.querySelector('#col_' + item.id)
				let colLink = document.createElement('div')
				colLink.setAttribute('id', 'link_' + item.id)
				colLink.style.display = 'flex'
				colLink.style.width = '100%'
				colLink.style.height = '100%'
				colLink.style.justifyContent = 'center'
				colLink.style.alignItems = 'center'
				colLink.innerText = 'click to create content'
				colLink.style.fontSize = fsS
				col.prepend(colLink)
			}
		})

		const preview = document.querySelector('#createContent')

		for (let key in preview.children) {
			if (preview.children[key].id === colID) {
				preview.children[key].removeEventListener('click', add_content)
				preview.children[key].addEventListener('click', update_content)
				selectedID = parseInt(key) + 1
			}
		}

		columnTitle = ''
		columnText = ''
		if (columnArray[selectedID - 1].image) {
			dropFiles = false
			return
		}

		//show delete button if image is set but not yet saved
		const del = document.querySelector('#canv_' + selectedID)
		if (del) {
			dropFiles = false
			return
		}

		dropFiles = true
	}

	const save_content = () => {
		selectedID = parseInt(selectedID)
		columnArray.forEach((item) => {
			if (item.id === selectedID) {
				if (columnTitle.length > 0) item.title = columnTitle
				else item.title = ''
				if (columnText.length > 0) item.text = columnText
				else item.text = ''

				let shortTitle = columnTitle
				let shortText = columnText
				const tt = document.querySelector('#title_' + selectedID)
				const txt = document.querySelector('#text_' + selectedID)

				//shorten the title and text if length is > 14
				if (item.title && item.title.length > 14) tt.innerText = shortTitle.slice(0, 15) + '...'
				else tt.innerText = shortTitle
				if (item.text && item.text.length > 14) txt.innerText = shortText.slice(0, 15) + '...'
				else txt.innerText = shortText

				// add the links

				if (selectedID === 1) {
					item.link = link1Value
					item.imgDesc = imgDesc1
				}

				if (selectedID === 2) {
					item.link = link2Value
					item.imgDesc = imgDesc2
				}

				if (selectedID === 3) {
					item.link = link3Value
					item.imgDesc = imgDesc3
				}
				if (selectedID === 4) {
					item.link = link4Value
					item.imgDesc = imgDesc4
				}
			}
		})

		columnTitle = null
		columnText = null
		selectedID = null
	}

	const save_block = () => {
		//error handling
		let error = false
		if (columnArray.length < 1) {
			showError = true
			error = true
			message = 'please create content'
		}
		columnArray.forEach((item) => {
			if (!item.image && !item.title && !item.text) {
				showError = true
				error = true
				message = 'some content is empty'
			}
		})

		if (error) return

		if (closeUpdate) uploadCmd = 'update'
		if (blockName === 'cover-slider') storeShowSliderButton.set(false)
		if (blockName === 'gallery') storeShowGalleryButton.set(false)

		uploadFiles = true
		storeUploader.set(true)
		uploader = upload_block()
		selectedID = null
		showSave = false
		showCreateContent = false
		storeShowFinishedBlocks.set(true)
		reset_all()
	}

	async function upload_block() {
		return columnArray
	}

	const create_preview_image = () => {
		let imageFile = null
		//get the object from objectArray
		//get the right array index for image
		let checkIndex = columnArray.length - selectedID
		if (checkIndex < 0)
			columnArray[columnArray.length - 1].image = imageFile =
				columnArray[columnArray.length - 1].image[Object.keys(columnArray[columnArray.length - 1].image)]
		else
			columnArray[selectedID - 1].image = imageFile =
				columnArray[selectedID - 1].image[Object.keys(columnArray[selectedID - 1].image)]

		let colImage = document.querySelector('#image_' + selectedID)
		let colCanv = document.querySelector('#canv_' + selectedID)

		if (!colImage) {
			const col = document.querySelector('#col_' + selectedID)
			colImage = document.createElement('div')
			colImage.setAttribute('id', 'image_' + selectedID)
			colImage.style.marginTop = '5px'
			col.append(colImage)
		}

		let reader = new FileReader()
		reader.readAsDataURL(imageFile)
		reader.onload = () => {
			let image = new Image()
			image.src = reader.result
			image.onload = () => {
				let canvas = document.createElement('canvas')
				canvas.setAttribute('id', 'canv_' + selectedID)
				let ctx = canvas.getContext('2d')

				if (image.width > image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVLANDSCAPE
				}

				if (image.width < image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVWIDTH
				}

				if (image.width === image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVHEIGHT
				}
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
				colImage.appendChild(canvas)

				if (!colCanv) {
					colImage.appendChild(canvas)
					dropFiles = false
					return
				}

				colImage.replaceChild(preview, colCanv)
				dropFiles = false
			}
		}
		return ''
	}

	const delete_preview_image = () => {
		const image = document.querySelector('#canv_' + selectedID)
		//get the right array index for image
		let checkIndex = columnArray.length - selectedID
		if (checkIndex < 0) columnArray[columnArray.length - 1].image = null
		else columnArray[selectedID - 1].image = null
		image.remove()
		dropFiles = true
	}

	//redirection if updateSingle is true
	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	// redirect helpers
	const redirect_helper = (h) => {
		switch (h) {
			case 'aitxt':
				window.open('https://you.com/search?q=who+are+you&tbm=youchat&cid=c2_cfdaa088-472e-436b-9a24-91b5cdb66250')
				break

			case 'aiimg':
				window.open('https://deepai.org/machine-learning-model/text2img')
				break

			case 'splchck':
				window.open('https://www.reverso.net/spell-checker/english-spelling-grammar/')
				break

			case 'resimg':
				window.open('https://imageresizer.com/')
				break

			case 'freeimg':
				window.open('https://www.pexels.com/')
				break

			case 'createlogo':
				window.open(
					'https://www.adobe.com/express/create/logo?clickref=1101lyhT5E8A&mv=affiliate&mv2=pz&as_camptype=&as_channel=affiliate&as_source=partnerize&as_campaign=designhub'
				)
				break
		}
	}

	//close main window
	const close_window = () => {
		storeShowFinishedBlocks.set(true)
		storeActiveBlock.set(null)
		storeIsLinked.set(false)
		if ($storeUpdateSingle) {
			const toClose = setTimeout(() => {
				document.location = '#/builder'
				clearTimeout(toClose)
			})
		}
		reset_all()
	}

	//dispatch functions
	const check_file = (e) => {
		if (e.detail.error === 'true') {
			showError = true
			message = 'Sorry, only one image per column allowed'
			return
		}

		//get the right array index for image
		let checkIndex = columnArray.length - selectedID
		if (checkIndex < 0) columnArray[columnArray.length - 1].image = e.detail.files[0]
		else columnArray[selectedID - 1].image = e.detail.files[0]
		create_preview_image()
	}

	const close_alert = () => {
		showError = false
	}

	const alert_delete = () => {
		showError = true
		message = 'delete entire block?'
		showOkButton = true
	}

	const alert_delete_block = async (blockName) => {
		closeUpdate = true

		const remainingBlocks = await delete_content(blockName)

		if (remainingBlocks) {
			// delete the linked site if is linked site
			if ($storeLinked) {
				linkedPages.forEach((l, index) => {
					if (l === $storeActiveBlock) {
						linkedPages.splice(index, 1)
					}
				})
			}

			showError = false
			remainingBlocks.sort()
			uploadCmd = 'upload'
			storeShowFinishedBlocks.set(true)
			storeActiveBlock.set(null)
			if (blockName === 'cover-slider') storeShowSliderButton.set(true)
			if (blockName === 'gallery') storeShowGalleryButton.set(true)

			if ($storeSingleImageBlock) storeSingleImageBlock.set(false)

			if (!updateSingle) {
				storeFinishedContent.set({ finishedBlocks: remainingBlocks, linkedSites: linkedPages })
			} else {
				storeFinishedContent.set({ finishedBlocks: [], linkedSites: [] })
				document.location = '#/builder'
			}
			reset_all()
		}
	}

	const reset_all = () => {
		columnArray = []
		selectedID = null
		showCreateContent = false
		storeUpdate.set(false)
		storeShowCreateButtons.set(true)
		closeUpdate = false
		deleteBlock = false
		showSave = false
		deleteBlock = false
		showTitle = false
		showIntro = false
		stBtnText = 'create title'
	}

	onDestroy(() => {
		stoUpdateSingle
		stoActiveBl
		stoUp
		stoUpdt
		stoHasLogo
		stoData
	})
</script>

{#if blockName && blockName !== 'mail'}
	<main id="updateblock" use:styles={{ colorMain, fsN }}>
		<div class="helper_row">
			<div
				class="helper"
				on:click={() => redirect_helper('aitxt')}
				on:keydown={() => redirect_helper('aitxt')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				create AI-text
			</div>
			<div
				class="helper"
				on:click={() => redirect_helper('aiimg')}
				on:keydown={() => redirect_helper('aiimg')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				create AI-image
			</div>
			<div
				class="helper"
				on:click={() => redirect_helper('splchck')}
				on:keydown={() => redirect_helper('splchck')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				spell-checker
			</div>
			<div
				class="helper"
				on:click={() => redirect_helper('resimg')}
				on:keydown={() => redirect_helper('resimg')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				resize images
			</div>
			<div
				class="helper"
				on:click={() => redirect_helper('freeimg')}
				on:keydown={() => redirect_helper('freeimg')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				free images
			</div>

			<div
				class="helper"
				on:click={() => redirect_helper('createlogo')}
				on:keydown={() => redirect_helper('createlogo')}
				use:styles={{ fsS, colorMain, buttonBgHover }}
			>
				free logo maker
			</div>
		</div>
		<div class="block_title" use:styles={{ fsL, colorMain }}>{blockName}</div>
		{#if blockName !== 'gallery' && blockName !== 'cover-slider' && !showTitle && !$storeIsLinked && columnArray.length < 2}
			<div class="chck_box">
				<input type="checkbox" bind:checked={$storeIsLinked} />
				<div style="margin-left:15px">create linked page</div>
			</div>
		{/if}

		{#if blockName !== 'cover-slider' && !$storeSingleImageBlock}
			<div class="button_container button_left" transition:slide={{ duration: 500 }}>
				{#if !$storeIsLinked}
					<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={show_title}>{stBtnText}</button>
				{/if}
				{#if showTitle && !$storeIsLinked}
					<input
						type="text"
						use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
						placeholder="enter title"
						bind:value={blockTitle}
						data-input
					/>
				{/if}
			</div>
		{/if}
		{#if blockName === 'gallery'}
			<div class="button_container button_left">
				<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={show_intro}>{stBtnIntro}</button>
				{#if showIntro}
					<textarea
						maxlength="400"
						use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
						placeholder="enter a short intro to your gallery"
						bind:value={blockIntro}
						data-input
					/>
				{/if}
			</div>
		{/if}

		{#if !$storeSingleImageBlock && !$storeIsLinked}
			<div class="button_container button_left" transition:slide={{ duration: 500 }}>
				<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={create_column_id}>create column</button>
			</div>
		{:else if !$storeSingleImageBlock && $storeIsLinked && columnArray < 2}
			<div class="button_container button_left" transition:slide={{ duration: 500 }}>
				<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={create_column_id}>create text</button>
			</div>
		{/if}

		{#if showCreateContent}
			<div class="create_content" id="createContent" transition:slide={{ duration: 1000 }} />
		{/if}

		{#if selectedID > 0}
			<section transition:slide={{ duration: 1000 }}>
				<TwoCols alignVertical="flex-start" column="260px">
					<div slot="column1" id="column_1">
						{#if dropFiles && !$storeIsLinked}
							<DropFiles on:upload={check_file} filesAccepted={acceptedFiles} allowedImages="1" />
						{:else if !dropFiles}
							<button on:click={delete_preview_image} use:styles={{ colorMain, fsXS, buttonBgHover }}
								>delete image</button
							>
						{/if}
					</div>

					<div slot="column2">
						{#if blockName.indexOf('Block') > -1 && !$storeIsLinked}
							{#if columnArray.length === 1 && !dropFiles}
								<div class="small_row">
									<div class="chck_box">
										<input type="checkbox" bind:checked={$storeSingleImageBlock} />
										<div style="margin-left:15px">single image block</div>
									</div>
									{#if $storeSingleImageBlock && showLogoCheckbox}
										<div transition:slide={{ duration: 500 }} class="chck_box">
											<input type="checkbox" bind:checked={hasLogo} />
											<div style="margin-left:15px">add logo</div>
										</div>
									{/if}
								</div>
							{/if}
							{#if selectedID === 1 && !$storeSingleImageBlock}
								<div class="small_row">
									<div class="chck_box">
										<input type="checkbox" bind:checked={setLink1} />
										<div style="margin-left:15px">create link</div>
									</div>
									{#if setLink1}
										{#if linkedPages.length > 0}
											<div class="chck_box">
												<input type="radio" bind:group={link1} value="linkPage" />
												<div style="margin-left:15px">link page</div>
											</div>
										{:else}
											<div class="chck_box">
												<div style="margin-left:15px">no page to link</div>
											</div>
										{/if}
										<div class="chck_box">
											<input type="radio" bind:group={link1} value="linkUrl" />
											<div style="margin-left:15px">link url</div>
										</div>
									{/if}
								</div>
								{#if link1 === 'linkUrl'}
									<div transition:slide={{ curation: 500 }}>
										<input
											type="text"
											bind:value={link1Value}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="enter url"
										/>
									</div>
								{:else if link1 === 'linkPage'}
									<div transition:slide={{ duration: 200 }}>
										{#if link1Value !== null}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value={link1Value}
											/>
										{:else}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value="select page"
											/>
										{/if}
										<input
											type="text"
											bind:value={imgDesc1}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="image description"
										/>
									</div>
								{/if}
							{:else if selectedID === 2}
								<div class="small_row">
									<div class="chck_box">
										<input type="checkbox" bind:checked={setLink2} />
										<div style="margin-left:15px">create link</div>
									</div>
									{#if setLink2}
										{#if linkedPages.length > 0}
											<div class="chck_box">
												<input type="radio" bind:group={link2} value="linkPage" />
												<div style="margin-left:15px">link page</div>
											</div>
										{:else}
											<div class="chck_box">
												<div style="margin-left:15px">no page to link</div>
											</div>
										{/if}
										<div class="chck_box">
											<input type="radio" bind:group={link2} value="linkUrl" />
											<div style="margin-left:15px">link url</div>
										</div>
									{/if}
								</div>
								{#if link2 === 'linkUrl'}
									<div transition:slide={{ curation: 500 }}>
										<input
											type="text"
											bind:value={link2Value}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="enter url"
										/>
									</div>
								{:else if link2 === 'linkPage'}
									<div transition:slide={{ duration: 200 }}>
										{#if link2Value !== null}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value={link2Value}
											/>
										{:else}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value="select page"
											/>
										{/if}
										<input
											type="text"
											bind:value={imgDesc2}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="image description"
										/>
									</div>
								{/if}
							{:else if selectedID === 3}
								<div class="small_row">
									<div class="chck_box">
										<input type="checkbox" bind:checked={setLink3} />
										<div style="margin-left:15px">create link</div>
									</div>
									{#if setLink3}
										{#if linkedPages.length > 0}
											<div class="chck_box">
												<input type="radio" bind:group={link3} value="linkPage" />
												<div style="margin-left:15px">link page</div>
											</div>
										{:else}
											<div class="chck_box">
												<div style="margin-left:15px">no page to link</div>
											</div>
										{/if}
										<div class="chck_box">
											<input type="radio" bind:group={link3} value="linkUrl" />
											<div style="margin-left:15px">link url</div>
										</div>
									{/if}
								</div>
								{#if link3 === 'linkUrl'}
									<div transition:slide={{ curation: 500 }}>
										<input
											type="text"
											bind:value={link3Value}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="enter url"
										/>
									</div>
								{:else if link3 === 'linkPage'}
									<div transition:slide={{ duration: 200 }}>
										{#if link3Value !== null}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value={link3Value}
											/>
										{:else}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value="select page"
											/>
										{/if}
										<input
											type="text"
											bind:value={imgDesc3}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="image description"
										/>
									</div>
								{/if}
							{:else if selectedID === 4}
								<div class="small_row">
									<div class="chck_box">
										<input type="checkbox" bind:checked={setLink4} />
										<div style="margin-left:15px">create link</div>
									</div>
									{#if setLink4}
										{#if linkedPages.length > 0}
											<div class="chck_box">
												<input type="radio" bind:group={link4} value="linkPage" />
												<div style="margin-left:15px">link page</div>
											</div>
										{:else}
											<div class="chck_box">
												<div style="margin-left:15px">no page to link</div>
											</div>
										{/if}
										<div class="chck_box">
											<input type="radio" bind:group={link4} value="linkUrl" />
											<div style="margin-left:15px">link url</div>
										</div>
									{/if}
								</div>
								{#if link4 === 'linkUrl'}
									<div transition:slide={{ duration: 500 }}>
										<input
											type="text"
											bind:value={link4Value}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="enter url"
										/>
									</div>
								{:else if link4 === 'linkPage'}
									<div transition:slide={{ duration: 200 }}>
										{#if link4Value !== null}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value={link4Value}
											/>
										{:else}
											<Select
												width="90%"
												marginBottom="10px"
												options={$storeLinked.toString()}
												on:select={link_block}
												value="select page"
											/>
										{/if}
										<input
											type="text"
											bind:value={imgDesc4}
											use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
											placeholder="image description"
										/>
									</div>
								{/if}
							{/if}
						{/if}

						{#if !$storeIsLinked}
							<div class="content_title" use:styles={{ fsS }}>Content for Column {selectedID}</div>
						{:else if $storeIsLinked}
							<div class="content_title" use:styles={{ fsS }}>Text for Linked Page</div>
						{/if}

						{#if !$storeIsLinked}
							<input
								type="text"
								use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
								placeholder="title for column {selectedID}"
								bind:value={columnTitle}
							/>
						{/if}

						<textarea
							use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
							placeholder="text for column {selectedID}"
							bind:value={columnText}
						/>
					</div>
				</TwoCols>
			</section>
			<div class="sub_buttons">
				<button on:click={delete_column} use:styles={{ colorMain, fsXS, buttonBgHover }}>remove</button>
				<button on:click={save_content} use:styles={{ colorMain, fsXS, buttonBgHover }}>save column </button>
			</div>
		{/if}
		<div class="button_container">
			<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>
			{#if showSave}
				<button on:click={save_block} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			{/if}
			{#if deleteBlock}
				<button on:click={alert_delete} use:styles={{ colorMain, fsXS, buttonBgHover }}>delete</button>
			{/if}
		</div>
	</main>
{/if}
{#if uploadFiles}
	{#await uploader then upload}
		<FileUploader
			files={upload}
			{blockTitle}
			{blockIntro}
			singleImageBlock={$storeSingleImageBlock}
			{hasLogo}
			isLinked={$storeIsLinked}
		/>
	{/await}
{/if}

{#if showError}
	<Shader>
		<div slot="content">
			<Alert {message} {showOkButton} on:alertok={() => alert_delete_block(blockName)} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	input[type='checkbox'],
	input[type='radio'] {
		outline: 0px;
		padding: 0px;
		margin: 0px;
	}

	input[type='text'],
	textarea {
		background-color: var(--inputBg);
		color: var(--colorMain);
		width: 90%;
		font-size: var(--fsS);
		border: 1px solid green;
	}

	input[data-input],
	textarea[data-input] {
		margin-left: 20px;
		width: 60%;
	}

	textarea {
		resize: none;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.button_left {
		justify-content: flex-start;
	}

	.sub_buttons {
		display: flex;
		width: 100%;
		justify-content: flex-end;
	}

	.create_content {
		position: relative;
		display: flex;
		width: 100%;
		height: clamp(150px, 16vw, 250px);
		margin-bottom: 1%;
		align-items: center;
	}

	.content_title {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		font-size: var(--fsS);
		margin-bottom: 15px;
	}

	.chck_box {
		display: flex;
		height: 30px;
		align-items: center;
		margin-bottom: 10px;
	}

	.small_row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		margin-bottom: 20px;
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}

	.helper {
		display: flex;
		justify-content: center;
		color: var(--colorMain);
		font-size: var(--fsS);
		cursor: pointer;
		border: 1px solid greenyellow;
		padding: 5px;
	}

	.helper:hover {
		background-color: var(--buttonBgHover);
	}

	.helper_row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		column-gap: 20px;
		margin-bottom: 20px;
	}
</style>
